import { PageTitle } from "@/components/page-title";
import { FinancialAccountForm } from "./_form";

function FinancialAccountNew() {
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <PageTitle>New financial account</PageTitle>
      <FinancialAccountForm />
    </div>
  );
}

export default FinancialAccountNew;
